
import React, { useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "../../components/Button/Button";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { useState } from "react";

import { useLocation, useParams } from "react-router-dom";
import { getRobotHistory, updateRobotParametersStatus } from "../DippingParameters/Services";
import { toast } from "react-toastify";
import { images } from "../../config/images";
import { getBatchId } from "./services";

function RobotParameter({ dippingPopup, setDippingPopup }) {
  const [robotHistoryData, setRobotHistoryData] = useState([]);
    const [isData, setIsData] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const [input, setInput] = useState(robotHistoryData);
    const [robotModal, setRobotModal] = useState({});
    const [batchTypeData,setBatchType] = useState([])
    const location = useLocation();
    const params = useParams()
    const batchType = location.state?.batch_types || params.id;


    useEffect(()=>{
      handleBatch()
    },[batchType])

    const handleBatch = async() =>{
      try{
        const resp = await getBatchId(batchType)
        if(resp.status == 200 || resp.status == 201){
          setBatchType(resp.data)
        }
      }
      catch(error){
        console.log("handlesubmit",error)
      }
    }

    const handleOpenModal = (i) => {
      // Set the `robotModal` state with the index `i`
      setRobotModal({ [i]: true });
    };
  
    useEffect(() => {
      handleModalData();
    }, []);
  
    const handleChange = (e, i, valueForRow) => {
      setIsDisabled(true);
      let newArray = [...robotHistoryData];
      if (
        valueForRow == "robot_default_values_first" ||
        valueForRow == "robot_default_values_second"
      ) {
        newArray[i].robot_parameter[valueForRow][0][e.target.name] =
          e.target.value;
      } else if (
        valueForRow == "temperature" ||
        valueForRow == "humidity" ||
        valueForRow == "remarks"
      ) {
        newArray[i].robot_parameter[e.target.name] = e.target.value;
      } else {
        newArray[i][e.target.name] = e.target.value;
      }
      setIsDisabled(false);
      setInput(newArray);
    };
    const param = useParams();
    const handleModalData = async (row) => {
      const params = {
        batch_id: batchType,
      };
      try {
        const resp = await getRobotHistory(params);
        //   setLoading(false);
        if (resp.status == 200 || resp.status == 201) {
          setRobotHistoryData(resp.data.payload);
          setIsData(true);
          // setBatchTypeForEditParams(row.batch_type);
        }
      } catch (error) {
        //   setLoading(false);
        setIsData(false);
        //   setBatchTypeForEditParams(row.batch_type);
        console.log("handleSubmit", error);
      }
      // setOpenModal(true);
    };
  
    const handleSubmit = async () => {
      try {
        input.forEach(async (element) => {
          const resp = await updateRobotParametersStatus(element);
          if (resp.status == 200 || resp.status == 201) {
            handleModalData()
            setRobotModal(false)
            // setOpenModal(false);
          }
        });
      } catch (error) {
        // setLoading(false);
        toast.error("Something was wrong, try again", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        console.log("handleSubmit", error);
      }
    };

  return (
    <>
      <div className="modal-container">
        <div className="modal-header">
          <div className="modal-title">Robot Parameter ({batchTypeData?.batch_type})</div>
          <div onClick={() => setDippingPopup(false)}>
            <CloseIcon />
          </div>
        </div>
        {isData ? (
          <>
            <div className="modal-table-wrapper">
              <TableContainer component={Paper} className="data-table">
                <Table className="modal-table modal-table-custom">
                  <TableHead className="robot-paramter-title">
                    <TableRow>
                      <TableCell rowSpan={4}>
                        <b>Date</b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>Robot</b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>Start Time</b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>Stop Time</b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>Shift</b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>Temp</b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>Humidity</b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>Tank</b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>
                          Immerse speed
                          <br />
                          (mm/s)
                        </b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>Beading dwell time (sec)</b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>Dwell time (sec)</b>
                      </TableCell>
                      <TableCell colSpan={4} width={1600}>
                        <b>Withdraw speed (mm/s)</b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>
                          Hold <br />
                          Time <br /> (s)
                        </b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>
                          Rot.
                          <br /> speed
                          <br />
                          (%)
                        </b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>
                          Rot.
                          <br /> time <br />
                          (s)
                        </b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>
                          {" "}
                          1st Rot.
                          <br /> hold time <br />
                          (s)
                        </b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>
                          Rot.
                          <br /> uphold time <br />
                          (s)
                        </b>
                      </TableCell>
                      <TableCell colSpan={4}>
                        <b>Depth (mm)</b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>
                          Beading
                          <br /> Length
                          <br /> (mm)
                        </b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>Remarks</b>
                      </TableCell>
                      <TableCell rowSpan={4}>
                        <b>Supervisor</b>
                      </TableCell>
                    </TableRow>
                    <TableRow className="tableRow">
                      <TableCell width={500}>Z1</TableCell>
                      <TableCell width={500}>Z2</TableCell>
                      <TableCell width={500}>Z3</TableCell>
                      <TableCell width={500}>Z4</TableCell>
                      <TableCell width={500}>Z1</TableCell>
                      <TableCell width={500}>Z2</TableCell>
                      <TableCell width={500}>Z3</TableCell>
                      <TableCell width={500}>Z4</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {robotHistoryData.map((colum, i, robot) => {

                      console.log("columcolum",colum)
                      return(
                        <>
                        <TableRow>
                          <TableCell rowSpan={4}>
                            {dayjs(colum.created_at).format("YYYY-MM-DD")}
                          </TableCell>
                          <TableCell rowSpan={4}>{colum?.robot_type}d</TableCell>
                          <TableCell rowSpan={4}>
            
                            {dayjs(colum.start_time).format("HH:mm:ss") !==
                            "Invalid Date"
                              ? dayjs(colum.start_time).format("HH:mm:ss")
                              : "-"}
                            {/* <TextField
                              style={{ width: "85px" }}
                              // value={handleTimeValue(colum.start_time)}
                              value={(dayjs(colum.start_time).format("HH:mm:ss") !== "Invalid Date") ? dayjs(colum.start_time).format("HH:mm:ss") : "-"}
                              name="start_time"
                              type="text"
                              autoComplete="off"
                            /> */}
                          </TableCell>
                          <TableCell rowSpan={4}>
                            {dayjs(colum.stop_time).format("HH:mm:ss") !==
                            "Invalid Date"
                              ? dayjs(colum.stop_time).format("HH:mm:ss")
                              : "-"}
                            {/* <TextField
                              style={{ width: "85px" }}
                              value={(dayjs(colum.stop_time).format("HH:mm:ss") !== "Invalid Date") ? dayjs(colum.stop_time).format("HH:mm:ss") : "-"}
                              // value={ colum.stop_time ? handleTimeValue(colum.stop_time) : "-"}
                              name="stop_time"
                              type="text"
                              autoComplete="off"
                            /> */}
                          </TableCell>
                          <TableCell rowSpan={4}>{colum.robot_shift}</TableCell>
                          <TableCell rowSpan={4}>
                            {colum?.robot_parameter?.temperature}
                          </TableCell>
                          {/* <TextField
                              value={colum?.robot_parameter?.temperature}
                              name="temperature"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "temperature")
                              }
                              autoComplete="off"
                            /></TableCell> */}
                          <TableCell rowSpan={4}>
                            {colum?.robot_parameter?.humidity}
                          </TableCell>
                          {/* <TextField
                              value={colum?.robot_parameter?.humidity}
                              name="humidity"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "humidity")
                              }
                              autoComplete="off"
                            /> */}

                          <TableCell>
                            {
                              colum.robot_parameter
                                ?.robot_default_values_first[0]?.tank
                            }{" "}
                          </TableCell>
                          {/* <TextField
                              value={
                                colum.robot_parameter
                                  
                                ?.robot_default_values_first[0]?.tank
                              }
                              autoComplete="off"
                              name="tank"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                            /> */}

                          <TableCell>{
                                colum.robot_parameter
                                  ?.robot_default_values_first[0]?.immerse_speed
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum.robot_parameter
                                  ?.robot_default_values_first[0]?.immerse_speed
                              }
                              name="immerse_speed"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum.robot_parameter
                                  ?.robot_default_values_first[0]
                                  ?.beadingdwell_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum.robot_parameter
                                  ?.robot_default_values_first[0]
                                  ?.beadingdwell_time
                              }
                              name="beadingdwell_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.dwell_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.dwell_time
                              }
                              name="dwell_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.w_zone_1
                              } </TableCell>
                            {/* <TextField
                              style={{ width: "50px" }}
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.w_zone_1
                              }
                              name="w_zone_1"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.w_zone_2
                              }</TableCell>
                            {/* <TextField
                              style={{ width: "50px" }}
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.w_zone_2
                              }
                              name="w_zone_2"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.w_zone_3
                              }</TableCell>
                            {/* <TextField
                              style={{ width: "50px" }}
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.w_zone_3
                              }
                              name="w_zone_3"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.w_zone_4
                              }</TableCell>
                            {/* <TextField
                              style={{ width: "50px" }}
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.w_zone_4
                              }
                              name="w_zone_4"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            /> */}
                       
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.hold_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.hold_time
                              }
                              name="hold_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            /> */}
                    
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]
                                  ?.rotation_speed
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]
                                  ?.rotation_speed
                              }
                              name="rotation_speed"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            /> */}
                       
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.rotation_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.rotation_time
                              }
                              name="rotation_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]
                                  ?.first_rotation_hold_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]
                                  ?.first_rotation_hold_time
                              }
                              name="first_rotation_hold_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]
                                  ?.rotations_uphold_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]
                                  ?.rotations_uphold_time
                              }
                              name="rotations_uphold_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.d_zone_1
                              }</TableCell>
                            {/* <TextField
                              style={{ width: "50px" }}
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.d_zone_1
                              }
                              name="d_zone_1"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.d_zone_2
                              }</TableCell>
                            {/* <TextField
                              style={{ width: "50px" }}
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.d_zone_2
                              }
                              name="d_zone_2"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.d_zone_3
                              }</TableCell>
                            {/* <TextField
                              style={{ width: "50px" }}
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.d_zone_3
                              }
                              name="d_zone_3"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.d_zone_4
                              }</TableCell>
                            {/* <TextField
                              style={{ width: "50px" }}
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]?.d_zone_4
                              }
                              name="d_zone_4"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]
                                  ?.beading_length
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_first[0]
                                  ?.beading_length
                              }
                              name="beading_length"
                              type="text"
                              onChange={(e) =>
                                handleChange(e, i, "robot_default_values_first")
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell rowSpan={4}>
                            <div onClick={() => handleOpenModal(i)}>
                              <img
                                src={images.remarks}
                                style={{ cursor: "pointer" }}
                                alt="remarks"
                              />
                            </div>
                            {robotModal[i] && (
                              <div className="remarksModal">
                                <CloseIcon
                                  style={{
                                    position: "absolute",
                                    zIndex: 99,
                                    right: 0,
                                    top: 0,
                                  }}
                                  onClick={() =>
                                    setRobotModal({ ...robotModal, [i]: false })
                                  }
                                />
                                <textarea
                                  name="remarks"
                                  style={{ padding: "22px", border: "none" }}
                                  rows="6"
                                  cols="30"
                                  value={colum.robot_parameter.remarks}
                                  onChange={(e) =>
                                    handleChange(e, i, "remarks")
                                  }
                                ></textarea>
                              </div>
                            )}
                          </TableCell>
                          <TableCell rowSpan={4}>{colum?.robot_parameter?.supervisor}</TableCell>
                            {/* <TextField
                              value={colum?.robot_parameter?.supervisor}
                              name="supervisor"
                              type="text"
                              autoComplete="off"
                            />
                          </TableCell> */}
                        </TableRow>
                        <TableRow>
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.tank
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.tank
                              }
                              name="tank"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]
                                  ?.immerse_speed
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]
                                  ?.immerse_speed
                              }
                              name="immerse_speed"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]
                                  ?.beadingdwell_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]
                                  ?.beadingdwell_time
                              }
                              name="beadingdwell_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.dwell_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.dwell_time
                              }
                              name="dwell_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.w_zone_1
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.w_zone_1
                              }
                              name="w_zone_1"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.w_zone_2
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.w_zone_2
                              }
                              name="w_zone_2"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.w_zone_3
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.w_zone_3
                              }
                              name="w_zone_3"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.w_zone_4
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.w_zone_4
                              }
                              name="w_zone_4"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.hold_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.hold_time
                              }
                              name="hold_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]
                                  ?.rotation_speed
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]
                                  ?.rotation_speed
                              }
                              name="rotation_speed"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]
                                  ?.rotation_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]
                                  ?.rotation_time
                              }
                              name="rotation_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]
                                  ?.first_rotation_hold_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]
                                  ?.first_rotation_hold_time
                              }
                              name="first_rotation_hold_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]
                                  ?.rotations_uphold_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]
                                  ?.rotations_uphold_time
                              }
                              name="rotations_uphold_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.d_zone_1
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.d_zone_1
                              }
                              name="d_zone_1"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.d_zone_2
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.d_zone_2
                              }
                              name="d_zone_2"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.d_zone_3
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.d_zone_3
                              }
                              name="d_zone_3"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.d_zone_4
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]?.d_zone_4
                              }
                              name="d_zone_4"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]
                                  ?.beading_length
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_oven_value_first[0]
                                  ?.beading_length
                              }
                              name="beading_length"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_oven_value_first"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                        </TableRow>
                        <TableRow>
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.tank
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.tank
                              }
                              name="tank"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]
                                  ?.immerse_speed
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]
                                  ?.immerse_speed
                              }
                              name="immerse_speed"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]
                                  ?.beadingdwell_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]
                                  ?.beadingdwell_time
                              }
                              name="beadingdwell_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.dwell_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.dwell_time
                              }
                              name="dwell_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.w_zone_1
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.w_zone_1
                              }
                              name="w_zone_1"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.w_zone_2
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.w_zone_2
                              }
                              name="w_zone_2"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.w_zone_3
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.w_zone_3
                              }
                              name="w_zone_3"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.w_zone_4
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.w_zone_4
                              }
                              name="w_zone_4"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.hold_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.hold_time
                              }
                              name="hold_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]
                                  ?.rotation_speed
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]
                                  ?.rotation_speed
                              }
                              name="rotation_speed"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]
                                  ?.rotation_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]
                                  ?.rotation_time
                              }
                              name="rotation_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]
                                  ?.first_rotation_hold_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]
                                  ?.first_rotation_hold_time
                              }
                              name="first_rotation_hold_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]
                                  ?.rotations_uphold_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]
                                  ?.rotations_uphold_time
                              }
                              name="rotations_uphold_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.d_zone_1
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.d_zone_1
                              }
                              name="d_zone_1"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.d_zone_2
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.d_zone_2
                              }
                              name="d_zone_2"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.d_zone_3
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.d_zone_3
                              }
                              name="d_zone_3"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.d_zone_4
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]?.d_zone_4
                              }
                              name="d_zone_4"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]
                                  ?.beading_length
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.robot_default_values_second[0]
                                  ?.beading_length
                              }
                              name="beading_length"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  "robot_default_values_second"
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                        </TableRow>
                        <TableRow>
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]?.tank
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]?.tank
                              }
                              name="tank"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]
                                  ?.immerse_speed
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]
                                  ?.immerse_speed
                              }
                              name="immerse_speed"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]
                                  ?.beadingdwell_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]
                                  ?.beadingdwell_time
                              }
                              name="beadingdwell_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]?.dwell_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]?.dwell_time
                              }
                              name="dwell_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]?.w_zone_1
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]?.w_zone_1
                              }
                              name="w_zone_1"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]?.w_zone_2
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]?.w_zone_2
                              }
                              name="w_zone_2"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]?.w_zone_3
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]?.w_zone_3
                              }
                              name="w_zone_3"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]?.w_zone_4
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]?.w_zone_4
                              }
                              name="w_zone_4"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]?.hold_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]?.hold_time
                              }
                              name="hold_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]
                                  ?.rotation_speed
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]
                                  ?.rotation_speed
                              }
                              name="rotation_speed"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]
                                  ?.rotation_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]
                                  ?.rotation_time
                              }
                              name="rotation_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]
                                  ?.first_rotation_hold_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]
                                  ?.first_rotation_hold_time
                              }
                              name="first_rotation_hold_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]
                                  ?.rotations_uphold_time
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]
                                  ?.rotations_uphold_time
                              }
                              name="rotations_uphold_time"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]?.d_zone_1
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]?.d_zone_1
                              }
                              name="d_zone_1"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]?.d_zone_2
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]?.d_zone_2
                              }
                              name="d_zone_2"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]?.d_zone_3
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]?.d_zone_3
                              }
                              name="d_zone_3"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]?.d_zone_4
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]?.d_zone_4
                              }
                              name="d_zone_4"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                          <TableCell>{
                                colum?.robot_parameter
                                  ?.robot_oven_value_second[0]
                                  ?.beading_length
                              }</TableCell>
                            {/* <TextField
                              value={
                                colum?.robot_parameter
                                  ?.[0]
                                  ?.beading_length
                              }
                              name="beading_length"
                              type="text"
                              onChange={(e) =>
                                handleChange(
                                  e,
                                  i,
                                  ""
                                )
                              }
                              autoComplete="off"
                            />
                          </TableCell> */}
                        </TableRow>
                      </>
                      )
                    }

                    
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <div
                aria-disabled={isDisabled}
                className="modal-submit-button common-button"
              >
                <Button
                  title="Submit"
                  onClick={handleSubmit}
                  className={`${
                    isDisabled
                      ? "disabledd-btn"
                      : "modal-submit-button common-button"
                  }`}
                  
                />
              </div>
            </div>
          </>
        ) : (
          <img src={images.notFoundImage} className="notfound-image" />
        )}
      </div>
      <div className="modal-overlay" onClick={() => setDippingPopup(false)}></div>
    </>
  );
}

export default RobotParameter;
